import axios from 'axios'
import constants from '../lib/constants'
import _ from 'lodash'

export const LOAD_CONTROL_MATERIALS = 'LOAD_CONTROL_MATERIALS'

export const getControlMaterials = (stripType) => {
  return (dispatch, getState) => {
    return axios.get(`${constants.API_URL}/control_materials/list`, {
      params: {
        qc_type: stripType || 'AUTO_CHECK'
      }
    })
    .then((response) => {
      dispatch({
        type: LOAD_CONTROL_MATERIALS,
        payload: response.data
      })
      return response
    })
  }
}

const ACTION_HANDLERS = {
  [LOAD_CONTROL_MATERIALS] : (state, action) => {
    const controlMaterialLots = action.payload
    const newState = _.keyBy(controlMaterialLots.control_materials, 'id')
    return newState
  }
}

const initialState = {}

export default function controlReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/controlMaterials.js